import { BaseQueryApi, BaseQueryFn, FetchArgs, FetchBaseQueryError, createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { baseUrlFunc } from '../../services/http';
import { RootState } from '..';
// import { RootState } from '../services/redux/store';

const prepareHeaders = (headers: Headers, api: Pick<BaseQueryApi, "getState" | "extra" | "endpoint" | "type" | "forced">) => {

    console.log((api.getState() as RootState).auth.login)
    const token = { data: { raw: '' }, ...(api.getState() as RootState).auth.login }.data.raw;
    if (token) {
        headers.set('Authorization', `Bearer ${token}`);
        headers.set('Content-Type', 'application/json');
    }
    return headers;
}

const baseQuery: BaseQueryFn = (...baseQueryArgs) => {
    const [args] = baseQueryArgs;



    return fetchBaseQuery({
        baseUrl: baseUrlFunc(args.subDomain),
        prepareHeaders: prepareHeaders
    })(...baseQueryArgs);
};

export const emptySplitApi = createApi({
    reducerPath: 'api',
    baseQuery: baseQuery,
    keepUnusedDataFor: 0.0001,
    endpoints: () => ({}),
});

export const apiWithTag = emptySplitApi.enhanceEndpoints({ addTagTypes: ['Risk', 'Users'] })